'use strict';

angular.module('msWidgets').directive('msWidgetCarouselCarousel', [function () {
  return {
    templateUrl: 'widgets/templates/carousel/carousel.html',
    controller: 'msWidgetCarouselController'
  };
}]).directive('msWidgetCarouselCarouselNext', [function () {
  return {
    templateUrl: 'widgets/templates/carousel/carousel_next.html'
  };
}]).controller('msWidgetCarouselController', ['$scope', '$timeout', function ($scope, $timeout) {
  $scope.carousel = {
    stage: 0
  };

  $scope.advanceStage = function () {
    $('.carousel-stage').addClass('leaving');
    $timeout(function () {
      $scope.carousel.stage = $scope.carousel.stage + 1;
      $timeout(function () {
        $('.carousel-stage').removeClass('leaving');
        setStageFocus();
      }, 300);
    }, 300);
  };

  $scope.retreatStage = function () {
    $('.carousel-stage').addClass('leaving');
    $timeout(function () {
      $scope.carousel.stage = $scope.carousel.stage - 1;
      $timeout(function () {
        $('.carousel-stage').removeClass('leaving');
        setStageFocus();
      }, 300);
    }, 300);
  };

  function setStageFocus() {
    $timeout(function () {
      var stage = angular.element('.activity-panel .carousel-stage');
      if (stage && stage[0]) {
        stage[0].focus();
      }
    }, 100);
  }
}]);